import { documentCategoryFromName } from './documentCategoryFromName'

const DATE_FORMATTER = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
})

function formatUpdatedAt(value) {
  if (!value) return 'Recently'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? String(value) : DATE_FORMATTER.format(date)
}

function sizeLabelFromDocument(doc) {
  // 'uploaded' is saved and idle, not mid-parse: claiming otherwise showed a
  // permanent "Processing..." on files nobody had asked a question about.
  if (doc.status === 'uploaded') return 'Saved'
  if (doc.status === 'processing') return 'Processing...'
  if (doc.status === 'failed') return 'Failed'
  if (Number.isFinite(Number(doc.pageCount))) {
    const count = Number(doc.pageCount)
    return `${count} ${count === 1 ? 'page' : 'pages'}`
  }
  return 'Ready'
}

/** Map a backend document shape to the Documents page item shape. */
export function documentItemFromDocument(doc = {}) {
  const name = String(doc.name || doc.originalFileName || doc.original_file_name || 'Untitled')
  return {
    id: String(doc.id ?? ''),
    name,
    category: documentCategoryFromName(name),
    updatedAt: formatUpdatedAt(doc.updatedAt ?? doc.updated_at ?? doc.created_at),
    sizeLabel: sizeLabelFromDocument(doc),
    status: String(doc.status || 'uploaded'),
  }
}
